export default "__VITE_ASSET__CFSpZ4OS__"